// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"b6f9ae8073a1f7023939","118":"019a6907986fac7043d8"}[chunkId] + ".js";
};